<template>
  <div>
    <b-button
      ref="hamburgerBtn"
      v-b-modal.modal-nav
      class="hamburger-container"
      :data-state="state"
      @click="togggleHamburger"
    >
      <div
        class="bar1"
        :style="{'background-color':sidebarBotFontColor}"
      />
      <div
        class="bar2"
        :style="{'background-color':sidebarBotFontColor}"
      />
      <div
        class="bar3"
        :style="{'background-color':sidebarBotFontColor}"
      />
    </b-button>
    <!-- Modal Component -->
    <b-modal
      id="modal-nav"
      title="Navigation"
      scrollable
      hide-footer
    >
      <NavButtons
        is-mobile
        @click="clickNavButtons"
      />
      <MobileNavigation />
    </b-modal>
  </div>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import MobileNavigation from '@/components/public/mobile/MobileNavigation.vue'
import NavButtons from '@/components/public/NavButtons/NavButtons.vue'

import { BvModalEvent } from 'bootstrap-vue'

const components = {
  MobileNavigation,
  NavButtons,
}

@Component({ components })
export default class HamburgerMenu extends Vue {
  state = 'open'

  mounted () {
    this.$root.$on('bv::modal::hide', (_: BvModalEvent, modalId: string) => {
      if (modalId === 'modal-nav') this.togggleHamburger()
    })
  }

  get sidebarBotFontColor () {
    return this.$typedStore.primary.app.config.storySettings.sidebarBot.fontColor
  }

  togggleHamburger () {
    if (this.state === 'closed') this.state = 'open'
    else this.state = 'closed'
  }

  updateStoryPath (path: string) {
    this.$typedStore.public.display.updatePrimaryStoryPath(path)
  }

  clickNavButtons () {
    this.$bvModal.hide('modal-nav')
  }
}

</script>

<style scoped>

.hamburger-container {
  display: inline-block;
  cursor: pointer;
}

.bar1, .bar2, .bar3,
.hamburger-container[data-state=open] .bar1,
.hamburger-container[data-state=open] .bar2,
.hamburger-container[data-state=open] .bar3 {
  width: 35px;
  height: 5px;
  margin: 6px 0;
  transition: 0.4s;
  pointer-events: none;
}

/* Rotate first bar */
.hamburger-container[data-state=closed] .bar1 {
  -webkit-transform: rotate(-45deg) translate(-9px, 6px) ;
  transform: rotate(-45deg) translate(-9px, 6px) ;
}

/* Fade out the second bar */
.hamburger-container[data-state=closed] .bar2 {
  opacity: 0;
}

/* Rotate last bar */
.hamburger-container[data-state=closed] .bar3 {
  -webkit-transform: rotate(45deg) translate(-8px, -8px) ;
  transform: rotate(45deg) translate(-8px, -8px) ;
}

</style>
